import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@unleash/proxy-client-react';

import { AppToggle } from '../../../clients/unleash/app-toggle-names';
import { useAppDispatch } from '../../../redux/hooks/app-hooks';
import { openAskAiAddKnowledgeModal } from '../../../redux/thunks/ask-ai-kb-thunk';

export type UseAddKnowledgeChatMessageButtonParams = {
    question: string;
    answer: string;
    turnId: string;
};

export const useAddKnowledgeChatMessageButton = ({
    question,
    answer,
    turnId,
}: UseAddKnowledgeChatMessageButtonParams) => {
    const { t } = useTranslation('translations');
    const enabled = useFlag(AppToggle.ADD_KNOWLEDGE);
    const dispatch = useAppDispatch();

    const onClick: React.MouseEventHandler = React.useCallback(
        (e) => {
            if (e instanceof MouseEvent) {
                e.stopPropagation();
            }

            dispatch(openAskAiAddKnowledgeModal({ title: question, answer }, { turn_id: turnId }));
        },
        [dispatch, question, answer, turnId]
    );

    return {
        onClick,
        disabled: !turnId,
        label: t('ask-ai-kb.add-to-kb'),
        enabled,
    };
};
